// extracted by css-extract-rspack-plugin
export default {"wrapper":"gquVqkXa0EaG4gis","input":"iWhnRcP6WIm7aYj9","text":"F4uOGhp0vZEVn4n_"};